var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlackDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 235,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 3.5,
    r: 3.5,
    fill: "#113"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 22.5,
    r: 3.5,
    fill: "#113"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 41.5,
    r: 3.5,
    fill: "#113"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 60.5,
    r: 3.5,
    fill: "#113"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 79.5,
    r: 3.5,
    fill: "#113"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 98.5,
    r: 3.5,
    fill: "#113"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 117.5,
    r: 3.5,
    fill: "#113"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 136.5,
    r: 3.5,
    fill: "#113"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 155.5,
    r: 3.5,
    fill: "#113"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 174.5,
    r: 3.5,
    fill: "#113"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 193.5,
    r: 3.5,
    fill: "#113"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 212.5,
    r: 3.5,
    fill: "#113"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.5,
    cy: 231.5,
    r: 3.5,
    fill: "#113"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgBlackDots as ReactComponent };